import React, {createContext, ReactNode, useContext, useState} from "react";
import {DirectionModel, TravelClaimModel} from "../types/travelClaims";

// Интерфейст для контекста модели обновления
interface TravelClaimUpdateContextType {
    model: TravelClaimModel;
    updateModel: (updates: Partial<TravelClaimModel>) => void;
    updateNestedModel: (id: string, updates: Partial<DirectionModel>) => void;
    addNestedModel: (nestedModel: DirectionModel) => void;
}

const TravelClaimContext = createContext<TravelClaimUpdateContextType | undefined>(undefined);

export const TravelClaimModelProvider = ({children}: { children: ReactNode }) => {
    const [model, setModel] = useState<TravelClaimModel>({
        comment: null,
        details: null,
        hotel_wishes: null,
        country: null,

        without_hotel: null,
        entry_date: null,
        departure_date: null,
        directions: []
    });

    // Обновление главной модели
    const updateModel = (updates: Partial<TravelClaimModel>) => {
        setModel((prevModel) => ({
            ...prevModel,
            ...updates,
        }));
    };

    // Обновление вложенных моделей в массиве
    const updateNestedModel = (id: string, updates: Partial<DirectionModel>) => {
        setModel((prevModel) => ({
            ...prevModel,
            directions: prevModel.directions.map((nestedModel) =>
                nestedModel.id === id ? {...nestedModel, ...updates} : nestedModel
            ),
        }));
    };

    // Добавление в массив вложенной модели
    const addNestedModel = (nestedModel: DirectionModel) => {
        setModel((prevModel) => ({
            ...prevModel,
            directions: [...prevModel.directions, nestedModel],
        }));
    };


    return (
        <TravelClaimContext.Provider value={{model, updateModel, updateNestedModel, addNestedModel}}>
            {children}
        </TravelClaimContext.Provider>
    );
};

export const useTravelClaimModel = () => {
    const context = useContext(TravelClaimContext);
    if (context === undefined) {
        throw new Error('Использование useTravelClaimModel должно быть внутри связанного с ним провайдера TravelClaimModelProvider');
    }
    return context;
};